import { fetchWithAuth, getCSRFToken } from "../auth";

const API_HOST = process.env.REACT_APP_ICC_TOOL_API_HOST;

export async function getMoveRequests(iccName) {
    const resp = await fetchWithAuth(`${API_HOST}asset/asset-move-requests/?asset=${iccName}`, {
        method: 'GET',
        headers: { 'X-CSRFToken': getCSRFToken(), 'Content-Type': 'application/json' },
        credentials: 'include'
    });
    if (!resp.ok) throw new Error("Failed to fetch move requests.");
    const data = await resp.json();
    return Array.isArray(data) ? data : (data.results || []);
}

export async function createMoveRequest(payload) {
    const resp = await fetchWithAuth(`${API_HOST}asset/asset-move-requests/`, {
        method: 'POST',
        headers: { 'X-CSRFToken': getCSRFToken(), 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify(payload)
    });
    if (!resp.ok) throw new Error("Failed to create move request.");
    return await resp.json();
}

export async function updateMoveRequest(id, payload) {
    const resp = await fetchWithAuth(`${API_HOST}asset/${id}/asset-move-requests/`, {
        method: 'PATCH',
        headers: { 'X-CSRFToken': getCSRFToken(), 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify(payload)
    });
    if (!resp.ok) throw new Error("Failed to update move request.");
    return await resp.json();
}

export async function cancelMoveRequest(id) {
    const resp = await fetchWithAuth(`${API_HOST}asset/${id}/asset-move-requests/`, {
        method: 'DELETE',
        headers: { 'X-CSRFToken': getCSRFToken() },
        credentials: 'include'
    });
    if (!resp.ok) throw new Error("Failed to cancel move request.");
}

export async function getActiveTeams() {
    const resp = await fetchWithAuth(`${API_HOST}teams/`, {
        method: 'GET',
        headers: { 'X-CSRFToken': getCSRFToken(), 'Content-Type': 'application/json' },
        credentials: 'include'
    });
    if (!resp.ok) throw new Error("Failed to fetch teams.");
    const data = await resp.json();
    const allTeams = Array.isArray(data) ? data : (data.results || []);
    return allTeams.filter(t => t.isActive);
}
